webpackJsonp([133],{

/***/ 1257:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MidanTaskTable_vue__ = __webpack_require__(3003);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_273e81b6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MidanTaskTable_vue__ = __webpack_require__(5503);
function injectStyle (ssrContext) {
  __webpack_require__(5501)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-273e81b6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MidanTaskTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_273e81b6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MidanTaskTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1346:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export removeDefaultParams */
/* unused harmony export trimParams */
/* harmony export (immutable) */ __webpack_exports__["c"] = removeEmptyParams;
/* harmony export (immutable) */ __webpack_exports__["d"] = setParams;
/* unused harmony export setDefaultParams */
/* unused harmony export conveDataType */
/* harmony export (immutable) */ __webpack_exports__["a"] = conveSomeDataType;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);


/*
 * 表格页面的通用方法
 * @Author: anker.wang
 * @Date: 2018-01-08 11:25:59
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-06-27 12:12:26
 * @Description 路由参数自动同步到搜索参数;在路由更新时获得表格数据;使用分页和搜索事件自动变更路由
 */



/* harmony default export */ __webpack_exports__["b"] = ({
  data: function data() {
    return {
      // 搜索表单字段
      search: {},
      // 搜索字段申明
      searchFieldType: {},
      // 表格数据
      table: [],
      // 分页参数
      pagination: {
        current_page: 1,
        per_page: 50,
        total: 0
      },
      refSearchForm: 'searchForm',
      lastSeachParams: {},
      isLoadTableInBeforeRouteEnter: true,
      isLoadTableInBeforeRouteUpdate: true
    };
  },

  // 路由进入时
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    // 在导航转入新的路由前
    next(function (vm) {
      if (vm.isLoadTableInBeforeRouteEnter) {
        // 处理路由参数
        var queryParams = vm.getRouterQueryParams(to.query);
        // 设置搜索参数
        vm.setSearchParams(queryParams);
        // 加载表格数据
        vm.loadTableData(queryParams);
      }
    });
  },

  // 路由更新时
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    if (this.isLoadTableInBeforeRouteUpdate) {
      // 处理路由参数
      var queryParams = this.getRouterQueryParams(to.query);
      // 加载表格数据
      this.loadTableData(queryParams);
    }
    // 继续加载路由
    next();
  },

  methods: {
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData: function getTableData(params) {},

    /**
     * 设置表格数据
     * @param {*} params
     */
    setTableData: function setTableData(_ref) {
      var data = _ref.data;

      this.$set(this, 'table', data.data);
      this.setPagination(data);
    },

    /**
     * 获得搜索参数
     */
    getSearchParams: function getSearchParams() {
      return this.search;
    },

    /**
     * 设置搜索参数
     */
    setSearchParams: function setSearchParams(params) {
      setParams(this.search, params);
    },

    /**
     * 获得搜索参数的类型声明
     * @description 从路由上同步参数时会造成获得全部都是字符串
     */
    getSearchFieldType: function getSearchFieldType() {
      return this.searchFieldType;
    },

    /**
     * 获取分页数据
     */
    getPagination: function getPagination() {
      return {
        current_page: this.pagination.current_page,
        per_page: this.pagination.per_page
      };
    },

    /**
     * 设置分页数据
     * @pagination {current_page, per_page, total}
     */
    setPagination: function setPagination(pagination) {
      // 转换数据类型
      pagination = conveSomeDataType(pagination, this.pagination);
      // 设置参数
      setParams(this.pagination, pagination);
    },

    /**
     * 处理分页大小时的变化
     * @param {*} val
     */
    handleSizePageChange: function handleSizePageChange(val) {
      this.setPagination({ per_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 处理页码变化
     * @param {*} val
     */
    handleCurrentPageChange: function handleCurrentPageChange(val) {
      this.setPagination({ current_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 获得路由参数
     * 必须 search 中存在的字段，通过申明的类型转换
     * @param {*} query
     */
    getRouterQueryParams: function getRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.$route.query;

      // 删除标识路由更新的空名字段
      if (query.hasOwnProperty('')) {
        delete query[''];
      }
      // 获得参数默认值

      var _$options$data$call = this.$options.data.call(this),
          pagination = _$options$data$call.pagination,
          search = _$options$data$call.search;

      return conveSomeDataType(query, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination), this.getSearchFieldType());
    },

    /**
     * 设置路由参数
     * @description 设置路由参数
     */
    setRouterQueryParams: function setRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _$options$data$call2 = this.$options.data.call(this),
          pagination = _$options$data$call2.pagination,
          search = _$options$data$call2.search;

      this.$router.replace({
        query: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, removeEmptyParams(trimParams(removeDefaultParams(query, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination)))), {
          // 用于相同的搜索参数时也触发路由更新
          '': __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('HHmmssSS')
        })
      });
    },

    /**
     * 加载表格数据
     * @param {*} params
     */
    loadTableData: function loadTableData(params) {
      // 移除空的参数
      params = removeEmptyParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getSearchParams(), params));
      // 设置默认分页大小值

      var _$options$data$call3 = this.$options.data.call(this),
          pagination = _$options$data$call3.pagination;

      params = setDefaultParams(params, {
        current_page: pagination.current_page,
        per_page: pagination.per_page
      });
      // 保存本次请求参数
      this.lastSeachParams = params;
      // 获得表格数据
      this.getTableData(params).then(this.setTableData);
    },

    /**
     * 刷新当前页的表格数据
     */
    onRefresh: function onRefresh() {
      // 根据上次请求数据再次获取
      return this.getTableData(this.lastSeachParams).then(this.setTableData);
    },

    /**
     * 搜索列表方法
     * @param {*} params
     */
    onSearch: function onSearch(params) {
      var _this = this;

      var search = function search() {
        _this.setPagination({ current_page: 1 });
        _this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this.getPagination(), _this.getSearchParams(), params));
      };
      // 验证填写参数
      var searchForm = this.$refs[this.refSearchForm];
      if (searchForm) {
        searchForm.validate(function (valid) {
          if (valid) {
            search();
          } else {
            _this.$message.error('搜索内容填写不正确！');
          }
        });
      } else {
        search();
      }
    },

    /**
     * 重置表单方法
     */
    resetSearch: function resetSearch() {
      this.$refs[this.refSearchForm].resetFields();
    }
  }

  /**
   * 移除参数中的默认参数
   * @param params
   * @param defaultParams
   * @returns {*}
   */
});function removeDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && params.hasOwnProperty(key)) {
      if (_.isEqual(defaultParams[key], params[key])) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 移除参数中字符串的前后空格
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function trimParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && typeof params[key] === 'string') {
      params[key] = params[key].trim();
    }
  }
  return params;
}

/**
 * 删除空的参数
 * @param params
 * @returns {*}
 */
function removeEmptyParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key)) {
      // 为数组时必须长度大于0
      if (params[key] instanceof Array && params[key].length === 0) {
        delete params[key];
      }
      // 空字符串或者null时删除字段
      if (params[key] === '' || params[key] === null) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 设置数据
 * @param params
 * @param newParams
 * @returns {*}
 */
function setParams(params, newParams) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && newParams.hasOwnProperty(key)) {
      params[key] = newParams[key];
    }
  }
  return params;
}

/**
 * 设置默认参数
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function setDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && !params.hasOwnProperty(key)) {
      params[key] = defaultParams[key];
    }
  }
  return params;
}

/**
 * 数据类型转换
 * @param value
 * @param type
 */
function conveDataType(value, type) {
  // 类型相同不用转换
  if (value.constructor !== type) {
    // 实际类型为对象时进入内部
    if (type.constructor === Object && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(type).length > 0) {
      for (var key in value) {
        if (value.hasOwnProperty(key)) {
          // 声明为对象时逐个转换
          value[key] = conveDataType(value[key], type[key]);
        }
      }
    } else {
      value = type(value);
    }
  }
  return value;
}

/**
 * 转换一些数据类型
 * @param params
 * @param defaultParams
 * @param types
 * @returns {*}
 * @description
 * types = {
 *   count: Number,
 *   object: {
 *     id: Number,
 *     date: Date
 *   },
 *   array: {
 *     0: Number,
 *     1: Boolean
 *   },
 * }
 */
function conveSomeDataType(params, defaultParams, types) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && params[key] !== null && params[key] !== undefined && defaultParams.hasOwnProperty(key)) {
      // 存在数据声明
      if (types && types.hasOwnProperty(key)) {
        params[key] = conveDataType(params[key], types[key]);
      } else if (defaultParams[key] !== null && defaultParams[key] !== undefined) {
        // 不存在获取默认参数的数据原类型
        var paramType = defaultParams[key].constructor;
        // 只对非对象数组的参数进行转换
        if (paramType !== Object) {
          params[key] = conveDataType(params[key], paramType);
        }
      }
    }
  }
  return params;
}

/***/ }),

/***/ 1512:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_xlsx__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_xlsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_xlsx__);





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var _this = this;

    return {
      archivedFields: [{
        prop: 'taskid',
        label: '任务ID',
        formatter: function formatter(row) {
          return 'TSK' + row.taskid;
        }
      }, {
        prop: 'title',
        label: '任务标题'
      }, {
        prop: 'type',
        label: '任务类型',
        formatter: function formatter(row) {
          return _this.getOptionLabel('allType', row.type);
        }
      }, {
        prop: 'assignnum',
        label: '完成人'
      }, {
        prop: 'salary',
        label: '赏金',
        formatter: function formatter(row) {
          return filter.hasPermission(250) ? row.salary : '*';
        }
      }, {
        prop: 'starttime_endtime',
        label: '任务时间',
        formatter: function formatter(row) {
          return row.starttime + '\n' + row.endtime;
        },
        width: '160px'
      }, {
        prop: 'city',
        label: '城市',
        formatter: function formatter(row) {
          return '' + row.provincename + row.cityname + row.areaname;
        }
      }, {
        prop: 'marketname',
        label: '门店名称'
      }, {
        prop: 'status',
        label: '任务状态',
        formatter: function formatter(row) {
          return _this.getOptionLabel('status', row.status);
        }
      }, {
        prop: 'adminname',
        label: '任务发布人'
      }, {
        prop: 'customerid',
        label: '所属客户',
        formatter: function formatter(row) {
          return row.customerid ? row.customer_name + '/' + row.customer_number : '平台';
        }
      }, {
        prop: 'publishtime',
        label: '发布时间',
        formatter: function formatter(row) {
          return '' + row.publishtime;
        },
        width: '160px'
      }],
      orderArchivedFields: [{
        prop: 'orderid',
        label: '工单ID',
        formatter: function formatter(row) {
          return 'ORD' + row.orderid;
        }
      }, {
        prop: 'title',
        label: '任务标题'
      }, {
        prop: 'type',
        label: '任务类型',
        formatter: function formatter(row) {
          return _this.getOptionLabel('allType', row.type);
        }
      }, {
        prop: 'userid',
        label: '完成人'
      }, {
        prop: 'salary',
        label: '赏金',
        formatter: function formatter(row) {
          return filter.hasPermission(250) ? row.salary : '*';
        }
      }, {
        prop: 'starttime_endtime',
        label: '任务时间',
        formatter: function formatter(row) {
          return row.starttime + '\n' + row.endtime;
        },
        width: '160px'
      }, {
        prop: 'city',
        label: '城市',
        formatter: function formatter(row) {
          return '' + row.provincename + row.cityname + row.areaname;
        }
      }, {
        prop: 'marketname',
        label: '门店名称'
      }, {
        prop: 'status',
        label: '任务状态',
        formatter: function formatter(row) {
          return _this.getOptionLabel('status', row.status);
        }
      }, {
        prop: 'adminname',
        label: '任务发布人'
      }, {
        prop: 'customerid',
        label: '所属客户',
        formatter: function formatter(row) {
          return row.customerid ? row.customer_name + '/' + row.customer_number : '平台';
        }
      }, {
        prop: 'review',
        label: '审核次数'
      }, {
        prop: 'publishtime',
        label: '发布/更新时间',
        formatter: function formatter(row) {
          return row.publishtime + '\n' + (row.lastupdatetime || '');
        },
        width: '160px'
      }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Vuex.mapState({
    options: function options(state) {
      return state.order.options;
    }
  })),
  methods: {
    onUploadFile: function onUploadFile(file, taskType) {
      var _this2 = this;

      var fileType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 6;

      var isLt10M = file.raw.size / 1024 / 1024 < 10;
      if (taskType === 231) {
        fileType = 8;
      }

      if (!isLt10M) {
        this.$message.error('大小不能超过10MB!');
        this.$refs.upload.clearFiles();
        return false;
      }

      var formData = new FormData();
      formData.append('file', file.raw);
      formData.append('collection_type', 2); // 集合类型为2
      formData.append('type', taskType);
      formData.append('file_type', fileType);

      request.common('createTaskBatch', formData).then(function (_ref) {
        var data = _ref.data;

        _this2.$message({
          showClose: true,
          message: '上传成功',
          type: 'success'
        });
        _this2.onSearch();
      });
    },
    createTaskBatch: function createTaskBatch(file) {
      var _this3 = this;

      var formData = new FormData();
      formData.append('file', file.raw);

      request.common('createTaskBatchJob', formData).then(function (_ref2) {
        var data = _ref2.data;

        _this3.$message({
          showClose: true,
          message: '上传成功',
          type: 'success'
        });
        _this3.onSearch();
      });
    },
    createTaskBatchWithTemplate: function createTaskBatchWithTemplate(file) {
      var _this4 = this;

      var formData = new FormData();
      formData.append('file', file.raw);

      request.common('createTaskWithTemplateBatchJob', formData).then(function (_ref3) {
        var data = _ref3.data;

        _this4.$message({
          showClose: true,
          message: '上传成功',
          type: 'success'
        });
        _this4.onSearch();
      });
    },
    uploadAuditReferenceBatch: function uploadAuditReferenceBatch(file) {
      var _this5 = this;

      var isLt10M = file.raw.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        this.$message.error('大小不能超过10MB!');
        return false;
      }
      var formData = new FormData();
      formData.append('file', file.raw);

      request.common('importTaskAuditReferenceBatchJob', formData).then(function () {
        _this5.$message({
          showClose: true,
          message: '上传成功',
          type: 'success'
        });
        _this5.onSearch();
      });
    },
    editTaskBatch: function editTaskBatch(file) {
      var _this6 = this;

      var formData = new FormData();
      formData.append('file', file.raw);

      request.common('editTaskBatchJob', formData).then(function (_ref4) {
        var data = _ref4.data;

        _this6.$message({
          showClose: true,
          message: '上传成功',
          type: 'success'
        });
        _this6.onSearch();
      });
    },
    deleteTaskBatch: function deleteTaskBatch(file) {
      var _this7 = this;

      var formData = new FormData();
      formData.append('file', file.raw);

      request.common('deleteTaskBatchJob', formData).then(function (_ref5) {
        var data = _ref5.data;

        _this7.$message({
          showClose: true,
          message: '上传成功',
          type: 'success'
        });
        _this7.onSearch();
      });
    },
    reactivateTaskBatch: function reactivateTaskBatch(file) {
      var _this8 = this;

      var formData = new FormData();
      formData.append('file', file.raw);

      request.common('reactivateTaskBatchJob', formData).then(function (_ref6) {
        var data = _ref6.data;

        _this8.$message({
          showClose: true,
          message: '上传成功',
          type: 'success'
        });
        _this8.onSearch();
      });
    },

    // 解析上传的excel文件 看一下是否超过MaxRowLimit
    parseExcelFile: function parseExcelFile(file) {
      var maxRowLimit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20000;

      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var isSatisfy = true;
        var errorMessage = '';
        // 先校验一下文件的大小
        var isLt10M = file.size / 1024 / 1024 < 10;
        if (!isLt10M) {
          isSatisfy = false;
          errorMessage = '上传表格行数超过10M，可能引起性能故障并导致更新失败。请与产品联系后上传，产品开发将关注后续更新情况。';
          return resolve({ isSatisfy: isSatisfy, errorMessage: errorMessage });
        }
        var reader = new FileReader();
        reader.onload = function (e) {
          try {
            var data = new Uint8Array(e.target.result);
            var workbook = __WEBPACK_IMPORTED_MODULE_4_xlsx___default.a.read(data, { type: 'array' });

            var firstSheetName = workbook.SheetNames[0];
            var worksheet = workbook.Sheets[firstSheetName];

            var jsonData = __WEBPACK_IMPORTED_MODULE_4_xlsx___default.a.utils.sheet_to_json(worksheet, { header: 1 });
            // 计算数据条数，减去第一行标题
            var rowCount = jsonData.length - 1;
            // 超过限定的长度
            if (rowCount > maxRowLimit) {
              isSatisfy = false;
              errorMessage = '\u4E0A\u4F20\u8868\u683C\u884C\u6570\u8D85\u8FC7' + maxRowLimit + '\u6761\uFF0C\u53EF\u80FD\u5F15\u8D77\u6027\u80FD\u6545\u969C\u5E76\u5BFC\u81F4\u66F4\u65B0\u5931\u8D25\u3002\u8BF7\u4E0E\u4EA7\u54C1\u8054\u7CFB\u540E\u4E0A\u4F20\uFF0C\u4EA7\u54C1\u5F00\u53D1\u5C06\u5173\u6CE8\u540E\u7EED\u66F4\u65B0\u60C5\u51B5\u3002';
            } else {
              isSatisfy = true;
            }
            return resolve({ isSatisfy: isSatisfy, errorMessage: errorMessage });
          } catch (error) {
            reject(Error('\u6587\u4EF6\u89E3\u6790\u5931\u8D25: ' + error.message));
            throw new Error(error);
          }
        };
        reader.onerror = function () {
          reject(Error('文件读取失败'));
        };
        reader.readAsArrayBuffer(file);
      });
    },

    // 上传任务可执行时间段 需要先校验一下他的行数
    taskAvailableTimeBatch: function taskAvailableTimeBatch(file) {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _ref7, isSatisfy, errorMessage;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this9.$store.commit('OPEN_LOADING');
                _context.next = 4;
                return _this9.parseExcelFile(file.raw, 20000);

              case 4:
                _ref7 = _context.sent;
                isSatisfy = _ref7.isSatisfy;
                errorMessage = _ref7.errorMessage;

                _this9.$store.commit('CLOSE_LOADING');
                // 超过限制 提示

                if (isSatisfy) {
                  _context.next = 22;
                  break;
                }

                _context.prev = 9;
                _context.next = 12;
                return _this9.$confirm(errorMessage, '警告', {
                  type: 'warning',
                  confirmButtonText: '已联系，继续操作',
                  cancelButtonText: '取消'
                });

              case 12:
                _context.next = 14;
                return _this9.uploadTaskAvailableTimeBatch(file);

              case 14:
                _context.next = 20;
                break;

              case 16:
                _context.prev = 16;
                _context.t0 = _context['catch'](9);

                _this9.$message.info('已取消上传');
                throw new Error(_context.t0);

              case 20:
                _context.next = 24;
                break;

              case 22:
                _context.next = 24;
                return _this9.uploadTaskAvailableTimeBatch(file);

              case 24:
                _context.next = 30;
                break;

              case 26:
                _context.prev = 26;
                _context.t1 = _context['catch'](0);

                _this9.$message.error(_context.t1);
                throw new Error(_context.t1);

              case 30:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this9, [[0, 26], [9, 16]]);
      }))();
    },

    // 上传excel
    uploadTaskAvailableTimeBatch: function uploadTaskAvailableTimeBatch(file) {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var formData;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                formData = new FormData();

                formData.append('file', file.raw);
                _context2.next = 4;
                return request.common('taskAvailableTimeBatchJob', formData);

              case 4:
                _this10.$message({
                  showClose: true,
                  message: '上传成功',
                  type: 'success'
                });
                _this10.onSearch();

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this10);
      }))();
    },

    // 任务可执行时间端 点击
    confirmTaskAvailableTimeBatch: function confirmTaskAvailableTimeBatch(e) {
      e.stopPropagation();
      this.$refs['upload'].$refs['upload-inner'].handleClick();
    },
    onPublishTask: function onPublishTask(task) {
      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var totalSalary;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!moment(task.taskendtime).isBefore(moment())) {
                  _context3.next = 4;
                  break;
                }

                _this11.$message.error('任务结束时间必须大于当前时间');
                _context3.next = 15;
                break;

              case 4:
                totalSalary = _.round(task.hirenum * task.salary, 2);
                _context3.next = 7;
                return _this11.$prompt('\u4EFB\u52A1[' + task.taskid + ']\u7684\u62A5\u916C' + task.salary + '\u5143\uFF0C\u9700\u8981' + task.hirenum + '\u4EBA\uFF0C\u8BF7\u8F93\u5165\u603B\u91D1\u989D\uFF1A' + totalSalary, '提示', {
                  confirmButtonText: '发布',
                  cancelButtonText: '取消',
                  inputPattern: new RegExp('^' + totalSalary + '$'),
                  inputErrorMessage: '金额输入错误',
                  inputPlaceholder: totalSalary,
                  closeOnClickModal: false
                });

              case 7:
                _context3.next = 9;
                return request.alert('taskPublish', { taskid: task.taskid });

              case 9:
                _this11.$store.commit('OPEN_LOADING');
                _context3.next = 12;
                return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
                  setTimeout(function () {
                    resolve();
                    _this11.$store.commit('CLOSE_LOADING');
                  }, 2000);
                });

              case 12:
                _context3.next = 14;
                return _this11.onRefresh();

              case 14:

                _this11.$message({
                  showClose: true,
                  message: '\u4EFB\u52A1[' + task.taskid + ']\u53D1\u5E03\u6210\u529F',
                  type: 'success'
                });

              case 15:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this11);
      }))();
    },
    getOptionLabel: function getOptionLabel(optType, val) {
      var type = this.options[optType].find(function (one) {
        return one.value === val;
      });
      return type ? type.label : '';
    },
    countDown: function countDown(date) {
      var futureTs = (Date.parse(date) + '').substr(0, 10);
      var currentTs = (new Date().getTime() + '').substr(0, 10);
      var interval = futureTs - currentTs;

      if (interval < 0) {
        return '';
      }

      return filter.formatTimerHumanize(interval);
    }
  }
});

/***/ }),

/***/ 1514:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TaskDescButton'
});

/***/ }),

/***/ 1548:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_area_components_ContainmentAreaCascader__ = __webpack_require__(1600);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ContainmentAreaCascader: __WEBPACK_IMPORTED_MODULE_1__views_area_components_ContainmentAreaCascader__["a" /* default */]
  },
  props: {
    searchValue: Object,
    showAddtoTaskgroupTargetNum: {
      type: Boolean,
      default: false
    },
    showExcludeProject: {
      type: Boolean,
      default: false
    },
    showPlatformSearch: {
      type: Boolean,
      default: false
    },
    type: {
      type: Number,
      default: 1 // 1工单 2任务 3任务&工单
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Vuex.mapState({
    options: function options(state) {
      return state.order.options;
    }
  }), Vuex.mapGetters('order', ['getSortedTaskTypes']), {
    search: function search() {
      return this.searchValue;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, request.map(['getProjectTable', 'getProjectDetail', 'getBatchTable', 'getBatchDetail']), Vuex.mapActions(['getPlatformUsersIndex', 'getPlatformUsersDetail']), {
    onSearch: function onSearch() {
      if (this.search.onlineRange) {
        this.searchValue.start_begin = this.search.onlineRange[0];
        this.searchValue.start_end = this.search.onlineRange[1];
      }
      if (this.search.offlineRange) {
        this.searchValue.endtime_begin = this.search.offlineRange[0];
        this.searchValue.endtime_end = this.search.offlineRange[1];
      }
      if (this.search.lastupdatetimeRange) {
        this.searchValue.lastupdatetime_begin = this.search.lastupdatetimeRange[0];
        this.searchValue.lastupdatetime_end = this.search.lastupdatetimeRange[1];
      }
      if (this.search.userfinishtime) {
        this.searchValue.userfinishtime_begin = this.search.userfinishtime[0];
        this.searchValue.userfinishtime_end = this.search.userfinishtime[1];
      }
      this.$emit('onSearch');
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
      this.search.query_areas = [];
      if (this.type === 1) {
        this.search.finish_query_areas = [];
      }
    },
    projectIdChanged: function projectIdChanged() {
      if (this.search.batchid.length > 0) {
        this.search.batchid = [];
      }
    }
  })
});

/***/ }),

/***/ 1549:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__);

//
//
//
//
//
//
//
//
//
//
//
//
//

/** 省市区多选；v-model 为 ["1","1,2","1,2,3"] */
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ContainmentAreaCascader',
  props: {
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    placeholder: {
      type: String,
      default: '请选择'
    }
  },
  data: function data() {
    return {
      chinaAreaData: []
    };
  },

  computed: {
    cascaderValue: function cascaderValue() {
      return (this.value || []).map(function (s) {
        return String(s).split(',').map(Number).filter(function (n) {
          return !__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default()(n);
        });
      }).filter(function (p) {
        return p.length;
      });
    }
  },
  created: function created() {
    var _this = this;

    request.alert('queryAllFormatted').then(function (_ref) {
      var data = _ref.data;

      _this.chinaAreaData = Array.isArray(data) ? data : Array.isArray(data && data.data) ? data.data : [];
    }).catch(function () {
      _this.chinaAreaData = [];
    });
  },

  methods: {
    onInput: function onInput(paths) {
      var next = (paths || []).map(function (p) {
        return p.join(',');
      });
      this.$emit('input', next);
      this.$emit('change', next);
    }
  }
});

/***/ }),

/***/ 1555:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TaskDescButton_vue__ = __webpack_require__(1514);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cbc218e4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TaskDescButton_vue__ = __webpack_require__(1558);
function injectStyle (ssrContext) {
  __webpack_require__(1556)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cbc218e4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TaskDescButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cbc218e4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TaskDescButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1556:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1557);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("39328c12", content, true, {});

/***/ }),

/***/ 1557:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"TaskDescButton.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 1558:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticStyle:{"position":"absolute","right":"200px","bottom":"18px","color":"red"},attrs:{"href":"https://slicejobs-tech.feishu.cn/wiki/IFSEwU6zhi3fetk53uScDxFPnwh","target":"_blank"}},[_vm._v("查看任务&工单&证据归档说明\n  ")]),_vm._v(" "),_c('a',{staticStyle:{"position":"absolute","right":"10px","bottom":"18px"},attrs:{"href":"http://img-cn-shanghai.aliyuncs.com/taskdesc/190603/50/ad816a4cf26d21609f15540fa701c174.png","target":"_blank"}},[_vm._v("查看任务&工单&零工说明\n  ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1600:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContainmentAreaCascader_vue__ = __webpack_require__(1549);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_647e61fc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContainmentAreaCascader_vue__ = __webpack_require__(1659);
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContainmentAreaCascader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_647e61fc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContainmentAreaCascader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1658:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderSearch_vue__ = __webpack_require__(1548);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ddb167e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderSearch_vue__ = __webpack_require__(1660);
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderSearch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ddb167e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderSearch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1659:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-cascader',{staticClass:"width-max",attrs:{"value":_vm.cascaderValue,"options":_vm.chinaAreaData,"props":{ multiple: true, checkStrictly: true },"filterable":"","clearable":"","placeholder":_vm.placeholder},on:{"input":_vm.onInput}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1660:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-panel',{attrs:{"collapse":true}},[_c('template',{slot:"header"},[_vm._v("搜索")]),_vm._v(" "),_c('el-form',{ref:"searchForm",attrs:{"model":_vm.search,"label-width":"96px","label-position":"right","size":"medium"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSearch()}}},[_c('div',{staticClass:"re-el-form__flex"},[_c('el-form-item',{attrs:{"label":"任务上线时间","prop":"onlineRange"}},[_c('el-date-picker',{staticClass:"width-max",attrs:{"value-format":"yyyy-MM-dd HH:mm:ss","type":"datetimerange","range-separator":"至","start-placeholder":"开始日期","end-placeholder":"结束日期","align":"center","clearable":""},model:{value:(_vm.search.onlineRange),callback:function ($$v) {_vm.$set(_vm.search, "onlineRange", $$v)},expression:"search.onlineRange"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"任务下线时间","prop":"offlineRange"}},[_c('el-date-picker',{staticClass:"width-max",attrs:{"value-format":"yyyy-MM-dd HH:mm:ss","type":"datetimerange","range-separator":"至","start-placeholder":"开始日期","end-placeholder":"结束日期","align":"center","clearable":""},model:{value:(_vm.search.offlineRange),callback:function ($$v) {_vm.$set(_vm.search, "offlineRange", $$v)},expression:"search.offlineRange"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"任务更新时间","prop":"lastupdatetimeRange"}},[_c('el-date-picker',{staticClass:"width-max",attrs:{"value-format":"yyyy-MM-dd HH:mm:ss","type":"datetimerange","range-separator":"至","start-placeholder":"开始日期","end-placeholder":"结束日期","align":"center","clearable":""},model:{value:(_vm.search.lastupdatetimeRange),callback:function ($$v) {_vm.$set(_vm.search, "lastupdatetimeRange", $$v)},expression:"search.lastupdatetimeRange"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"项目","prop":"projectid"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","multiple":"","id-key":"number","label-key":"name","value-key":"id","placeholder":"请输入项目 名称/编号 进行搜索","query-request":_vm.getProjectTable,"find-request":_vm.getProjectDetail},on:{"change":function($event){return _vm.projectIdChanged()}},model:{value:(_vm.search.projectid),callback:function ($$v) {_vm.$set(_vm.search, "projectid", $$v)},expression:"search.projectid"}})],1),_vm._v(" "),(_vm.showExcludeProject)?_c('el-form-item',{attrs:{"label":"排除项目","prop":"not_projectid"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","multiple":"","id-key":"number","label-key":"name","value-key":"id","placeholder":"请输入项目 名称/编号 进行搜索","query-request":_vm.getProjectTable,"find-request":_vm.getProjectDetail},model:{value:(_vm.search.not_projectid),callback:function ($$v) {_vm.$set(_vm.search, "not_projectid", $$v)},expression:"search.not_projectid"}})],1):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"label":"订单类型","prop":"type"}},[_c('el-select',{staticClass:"width-max",attrs:{"placeholder":"请选择订单类型","clearable":""},model:{value:(_vm.search.type),callback:function ($$v) {_vm.$set(_vm.search, "type", $$v)},expression:"search.type"}},_vm._l((_vm.getSortedTaskTypes),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}},[(item.deprecated)?[_c('span',{staticStyle:{"float":"left","color":"#9ba0a5"}},[_vm._v(_vm._s(item.label))]),_vm._v(" "),_c('span',{staticStyle:{"float":"right","color":"#8492a6","font-size":"13px"}},[_vm._v(_vm._s(item.desc)+"\n                ")])]:[_c('span',{staticStyle:{"float":"left"}},[_vm._v(_vm._s(item.label))]),_vm._v(" "),_c('span',{staticStyle:{"float":"right","color":"#8492a6","font-size":"13px"}},[_vm._v(_vm._s(item.desc))])]],2)}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"批次","prop":"batchid"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","multiple":"","disabled":!_vm.search.projectid,"id-key":"number","label-key":"detail","value-key":"id","placeholder":"请输入批次 名称/编号 进行搜索","query-request":function (_) { return _vm.getBatchTable(Object.assign({projectid: _vm.search.projectid}, _)); },"find-request":_vm.getBatchDetail},model:{value:(_vm.search.batchid),callback:function ($$v) {_vm.$set(_vm.search, "batchid", $$v)},expression:"search.batchid"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"订单状态","prop":"status"}},[_c('el-select',{staticClass:"width-max",attrs:{"multiple":"","placeholder":"请选择订单状态","clearable":""},model:{value:(_vm.search.status),callback:function ($$v) {_vm.$set(_vm.search, "status", $$v)},expression:"search.status"}},[(_vm.type === 1)?_vm._l((_vm.options.orderstatus),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":String(item.value)}})}):(_vm.type === 2)?_vm._l((_vm.options.taskstatus),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":String(item.value)}})}):(_vm.type === 3)?_vm._l((_vm.options.status),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":String(item.value)}})}):_vm._e()],2)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"任务模板ID","prop":"templateid"}},[_c('el-input',{attrs:{"placeholder":"请输入任务模板id"},model:{value:(_vm.search.templateid),callback:function ($$v) {_vm.$set(_vm.search, "templateid", $$v)},expression:"search.templateid"}})],1),_vm._v(" "),(_vm.type !== 2)?_c('el-form-item',{attrs:{"label":"完成人ID","prop":"userid"}},[_c('el-input',{attrs:{"placeholder":"请输入完成人id","clearable":""},model:{value:(_vm.search.userid),callback:function ($$v) {_vm.$set(_vm.search, "userid", $$v)},expression:"search.userid"}})],1):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"label":"所在区域","prop":"taskmarketareaid"}},[_c('el-select',{staticClass:"width-max",attrs:{"placeholder":"请选择所在区域","clearable":""},model:{value:(_vm.search.taskmarketareaid),callback:function ($$v) {_vm.$set(_vm.search, "taskmarketareaid", $$v)},expression:"search.taskmarketareaid"}},_vm._l((_vm.options.taskmarketareaid),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"省市区","prop":"query_areas"}},[_c('containment-area-cascader',{attrs:{"placeholder":"请选择省市区"},model:{value:(_vm.search.query_areas),callback:function ($$v) {_vm.$set(_vm.search, "query_areas", $$v)},expression:"search.query_areas"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"超市名称","prop":"marketname"}},[_c('el-input',{attrs:{"placeholder":"请输入超市名称"},model:{value:(_vm.search.marketname),callback:function ($$v) {_vm.$set(_vm.search, "marketname", $$v)},expression:"search.marketname"}})],1),_vm._v(" "),(_vm.type !== 2)?_c('el-form-item',{attrs:{"label":"锁定状态","prop":"locked"}},[_c('el-select',{staticClass:"width-max",attrs:{"placeholder":"请选择锁定状态","clearable":""},model:{value:(_vm.search.locked),callback:function ($$v) {_vm.$set(_vm.search, "locked", $$v)},expression:"search.locked"}},_vm._l((_vm.options.locked),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1):_vm._e(),_vm._v(" "),(_vm.type !== 2)?_c('el-form-item',{staticClass:"re-el-form__interval",attrs:{"label":"审核次数"}},[_c('el-row',[_c('el-col',{attrs:{"span":11}},[_c('el-form-item',{attrs:{"prop":"review_begin","label-width":"0px"}},[_c('el-input',{attrs:{"placeholder":"最小值"},model:{value:(_vm.search.review_begin),callback:function ($$v) {_vm.$set(_vm.search, "review_begin", $$v)},expression:"search.review_begin"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":2}},[_c('span',[_vm._v("~")])]),_vm._v(" "),_c('el-col',{attrs:{"span":11}},[_c('el-form-item',{attrs:{"prop":"review_end","label-width":"0px"}},[_c('el-input',{attrs:{"placeholder":"最大值"},model:{value:(_vm.search.review_end),callback:function ($$v) {_vm.$set(_vm.search, "review_end", $$v)},expression:"search.review_end"}})],1)],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.type === 1)?_c('el-form-item',{staticClass:"re-el-form__interval",attrs:{"label":"用户完成时间","prop":"userfinishtime"}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"datetimerange","range-separator":"至","start-placeholder":"开始日期","end-placeholder":"结束日期","align":"right","clearable":"","default-time":['00:00:00', '23:59:59'],"value-format":"yyyy-MM-dd HH:mm:ss"},model:{value:(_vm.search.userfinishtime),callback:function ($$v) {_vm.$set(_vm.search, "userfinishtime", $$v)},expression:"search.userfinishtime"}})],1):_vm._e(),_vm._v(" "),(_vm.type === 1)?_c('el-form-item',{staticClass:"re-el-form__interval",attrs:{"label":"初审管理员","prop":"first_reviewerid"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","id-key":"id","keyword-key":"name","label-key":"name","value-key":"id","placeholder":"请输入管理员名称搜索","query-request":_vm.getPlatformUsersIndex,"find-request":_vm.getPlatformUsersDetail},model:{value:(_vm.search.first_reviewerid),callback:function ($$v) {_vm.$set(_vm.search, "first_reviewerid", $$v)},expression:"search.first_reviewerid"}})],1):_vm._e(),_vm._v(" "),(_vm.showAddtoTaskgroupTargetNum)?_c('el-form-item',{attrs:{"label":"目标数标记","prop":"addto_taskgroup_target_num"},scopedSlots:_vm._u([{key:"label",fn:function(){return [_c('span',[_vm._v("目标数标记"),_c('el-tooltip',{attrs:{"content":"自动群组目标数标记任务"}},[_c('i',{staticClass:"el-icon-warning"})])],1)]},proxy:true}],null,false,3089044144)},[_vm._v(" "),_c('el-select',{staticClass:"width-max",attrs:{"clearable":""},model:{value:(_vm.search.addto_taskgroup_target_num),callback:function ($$v) {_vm.$set(_vm.search, "addto_taskgroup_target_num", $$v)},expression:"search.addto_taskgroup_target_num"}},_vm._l((_vm.options.addto_taskgroup_target_num),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1):_vm._e(),_vm._v(" "),(_vm.showPlatformSearch)?_c('el-form-item',{attrs:{"label":"签到平台","prop":"start_app_type"}},[_c('el-select',{staticClass:"width-max",attrs:{"clearable":"","multiple":""},model:{value:(_vm.search.start_app_type),callback:function ($$v) {_vm.$set(_vm.search, "start_app_type", $$v)},expression:"search.start_app_type"}},_vm._l((_vm.options.app_type_list),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1):_vm._e(),_vm._v(" "),(_vm.showPlatformSearch)?_c('el-form-item',{attrs:{"label":"提交平台","prop":"finish_app_type"}},[_c('el-select',{staticClass:"width-max",attrs:{"clearable":"","multiple":""},model:{value:(_vm.search.finish_app_type),callback:function ($$v) {_vm.$set(_vm.search, "finish_app_type", $$v)},expression:"search.finish_app_type"}},_vm._l((_vm.options.app_type_list),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1):_vm._e(),_vm._v(" "),(_vm.showPlatformSearch)?_c('el-form-item',{attrs:{"label":"工单自主激活","prop":"reactive_by_user"}},[_c('el-select',{staticClass:"width-max",attrs:{"clearable":""},model:{value:(_vm.search.reactive_by_user),callback:function ($$v) {_vm.$set(_vm.search, "reactive_by_user", $$v)},expression:"search.reactive_by_user"}},[_c('el-option',{attrs:{"label":"是","value":1}}),_vm._v(" "),_c('el-option',{attrs:{"label":"否","value":2}})],1)],1):_vm._e()],1),_vm._v(" "),_c('el-row',[_c('div',{staticClass:"re-el-form__flex"},[_c('el-form-item',{attrs:{"label":"关键字","prop":"text"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"placeholder":"请输入关键字","clearable":""},model:{value:(_vm.search.text),callback:function ($$v) {_vm.$set(_vm.search, "text", $$v)},expression:"search.text"}})],1),_vm._v(" "),(_vm.type === 1)?_c('el-form-item',{attrs:{"label":"用户提交位置","prop":"finish_query_areas"}},[_c('containment-area-cascader',{attrs:{"placeholder":"请选择用户提交位置"},model:{value:(_vm.search.finish_query_areas),callback:function ($$v) {_vm.$set(_vm.search, "finish_query_areas", $$v)},expression:"search.finish_query_areas"}})],1):_vm._e()],1)]),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-search","native-type":"submit","size":"mini"}},[_vm._v("搜索\n      ")]),_vm._v(" "),_c('el-button',{attrs:{"size":"mini"},on:{"click":function($event){return _vm.resetForm('searchForm')}}},[_vm._v("重置\n      ")])],1)],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1699:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_task_components_buttons_TaskBatchPublishButton__ = __webpack_require__(1796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_task_components_buttons_TaskBatchDeleteButton__ = __webpack_require__(1797);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_task_components_buttons_TaskPublishOnSearchButton__ = __webpack_require__(1798);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_task_components_buttons_TaskCopyButton__ = __webpack_require__(2090);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_task_components_buttons_TaskDeleteButton__ = __webpack_require__(2094);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_mixins_table__ = __webpack_require__(1346);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_5__core_mixins_table__["b" /* default */]],
  components: {
    TaskCopyButton: __WEBPACK_IMPORTED_MODULE_3__views_task_components_buttons_TaskCopyButton__["a" /* default */],
    TaskPublishOnSearchButton: __WEBPACK_IMPORTED_MODULE_2__views_task_components_buttons_TaskPublishOnSearchButton__["a" /* default */],
    TaskBatchPublishButton: __WEBPACK_IMPORTED_MODULE_0__views_task_components_buttons_TaskBatchPublishButton__["a" /* default */],
    TaskBatchDeleteButton: __WEBPACK_IMPORTED_MODULE_1__views_task_components_buttons_TaskBatchDeleteButton__["a" /* default */],
    TaskDeleteButton: __WEBPACK_IMPORTED_MODULE_4__views_task_components_buttons_TaskDeleteButton__["a" /* default */]
  },
  props: {
    scope: Object
  }
});

/***/ }),

/***/ 1700:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  props: {
    multipleSelection: Array
  },
  data: function data() {
    return {
      dialogVisible: false,
      validAmount: 0,
      salary: 0.00,
      inputSalary: null
    };
  },

  methods: {
    onSubmit: function onSubmit() {
      var _this = this;

      if (parseFloat(this.inputSalary) !== parseFloat(this.salary)) {
        this.$message.error('总金额输入错误，请重新提交');
        return false;
      }

      var overTimeTask = this.multipleSelection.map(function (task) {
        if (moment(task.taskendtime).isBefore(moment())) {
          return task.taskid;
        }
      });

      overTimeTask = overTimeTask.filter(function (val) {
        return Boolean(val);
      });
      if (overTimeTask.length) {
        this.$message.error('任务结束时间必须晚于当前时间');
        return false;
      }
      var multipleIds = {
        'task_ids': this.multipleSelection.map(function (item) {
          return item.taskid;
        })
      };
      if (multipleIds.task_ids.length <= 0) {
        this.$message.error('请至少选择批量发布一个');
        this.dialogVisible = false;
        return false;
      }
      return request.alert('batchPublish', multipleIds).then(function (res) {
        _this.$message({
          showClose: true,
          message: '批量发布成功，成功' + res.data.success.length + '个,共' + multipleIds.task_ids.length + '个',
          type: 'success'
        });
        _this.dialogVisible = false;
        _this.$store.commit('OPEN_LOADING');
        setTimeout(function () {
          _this.$emit('clean');
          _this.$store.commit('CLOSE_LOADING');
        }, 2000);
      });
    },
    onStatisticalTotal: function onStatisticalTotal() {
      if (this.multipleSelection.length <= 0) {
        this.$message.error('最少选择一个任务发布');
        return false;
      }
      var validAmount = 0;
      var salary = 0.00;
      for (var i = 0; i < this.multipleSelection.length; i++) {
        if (this.multipleSelection.hasOwnProperty(i)) {
          var it = this.multipleSelection[i];
          if (it.status === 0) {
            validAmount++;
            salary = _.round(salary + it.salary * it.hirenum, 2);
          }
        }
      }

      if (validAmount <= 0) {
        this.$message.error('没有要发布的任务，请重新选择');
        return false;
      }
      this.validAmount = validAmount;
      this.salary = salary;
      this.dialogVisible = true;
    }
  }
});

/***/ }),

/***/ 1701:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  props: {
    multipleSelection: Array
  },
  methods: {
    onSubmit: function onSubmit() {
      var _this = this;

      var multipleIds = {
        'task_ids': this.multipleSelection.map(function (item) {
          return item.taskid;
        })
      };
      if (multipleIds.task_ids.length <= 0) {
        this.$message.error('请至少选择批量删除一个');
        return false;
      }
      return request.alert('batchDelete', multipleIds).then(function (res) {
        _this.$message({
          showClose: true,
          message: '批量删除成功，成功' + res.data.success + '个,共' + multipleIds.task_ids.length + '个',
          type: 'success'
        });
        _this.$store.commit('OPEN_LOADING');
        setTimeout(function () {
          _this.$emit('clean');
          _this.$store.commit('CLOSE_LOADING');
        }, 2000);
      });
    }
  }
});

/***/ }),

/***/ 1702:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  props: {
    search: Object
  },
  data: function data() {
    return {
      visible: false,
      count: null,
      salary: null,
      inputSalary: null
    };
  },

  watch: {
    visible: function visible(val) {
      if (!val) {
        this.close();
      }
    }
  },
  computed: {},
  methods: {
    open: function open() {
      var _this = this;

      this.visible = true;
      request.common('getTaskPublishOnSearchInfo', this.search).then(function (_ref) {
        var data = _ref.data;

        if (data.count <= 0) {
          _this.visible = false;
          _this.$message.error('搜索结果数量为0');
          return;
        }
        _this.count = data.count;
        _this.salary = _.round(data.salary, 2);
      });
    },
    close: function close() {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.$data, this.$options.data.call(this));
    },
    onSubmit: function onSubmit() {
      var _this2 = this;

      if (parseFloat(this.inputSalary) !== parseFloat(this.salary)) {
        this.$message.error('总金额输入错误，请重新提交');
        return false;
      }

      return request.alert('taskPublishOnSearch', this.search).then(function (_ref2) {
        var data = _ref2.data;

        var message = '发布搜索结果成功' + data.success.length + '个';
        var duration = 3000;
        var type = 'success';
        if (data.error.length) {
          message += ', \u9519\u8BEF' + data.error.length + '\u4E2A\uFF0C\u7B2C\u4E00\u4E2A\u9519\u8BEF\u539F\u56E0\uFF1A' + data.error[0].msg;
          duration = 0;
          type = 'warning';
        }
        _this2.$message({
          message: message,
          duration: duration,
          type: type,
          showClose: true
        });
        _this2.$store.commit('OPEN_LOADING');
        setTimeout(function () {
          _this2.close();
          _this2.$emit('refresh');
          _this2.$store.commit('CLOSE_LOADING');
        }, 2000);
      });
    }
  }
});

/***/ }),

/***/ 1703:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_components_RemoteSelect__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_area_components_AreaSearch__ = __webpack_require__(2091);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { AreaSearch: __WEBPACK_IMPORTED_MODULE_4__views_area_components_AreaSearch__["a" /* default */], RemoteSelect: __WEBPACK_IMPORTED_MODULE_3__core_components_RemoteSelect__["a" /* default */] },
  props: {
    taskid: String
  },
  data: function data() {
    return {
      copyConfigSwitch: {
        whitelist: true,
        whitelisttags: true,
        blacklist: true,
        blacklisttags: true
      },
      copyConfig: {
        blacklistString: '',
        whitelistString: '',
        whitelisttags: [],
        blacklisttags: []
      },
      copyInfo: {
        whitelist: [],
        whitelisttags: [],
        blacklist: [],
        blacklisttags: []
      },
      outerVisible: false,
      innerVisible: false,
      activeName: 'list',
      market: [],
      marketid: null,
      form: {
        selectMarket: null
      },
      marketInfo: null,
      selectMarket: null
    };
  },

  watch: {
    outerVisible: function outerVisible(value) {
      if (!value) {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(this.$data, this.$options.data());
      }
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, request.map(['queryMarket', 'getUserTagTable']), {
    onSubmit: function onSubmit() {
      var detail = {
        task_id: this.taskid
      };
      if (this.activeName === 'list' || this.activeName === 'market') {
        var marketInfo = this.form.selectMarket;
        var market = marketInfo.split('\n');
        if (market.length < 1) {
          this.$message.error('请至少输入一个卖场');
          return false;
        }

        for (var n = 0; n < market.length; n++) {
          if (!market[n] || market[n] === '') {
            market.splice(n, 1);
          }
        }

        if (market.length === 1) {
          var marketIds = market[0].split('/');
          detail.market_id = marketIds[1];
          detail.market_name = marketIds[0];
          this.copyTaskSumit(detail);
          return false;
        }
        detail.market_ids = [];
        for (var i = 0; i < market.length; i++) {
          var _marketIds = market[i].split('/');
          detail.market_ids.push(_marketIds);
        }
        this.batchCopyTaskSumit(detail);
        return false;
      } else if (this.activeName === 'area') {
        var provinceInfo = this.$refs.provinces.form;
        detail.province_id = provinceInfo.provinceid;
        detail.city_id = provinceInfo.cityid;
        detail.area_id = provinceInfo.areaid;
      } else if (this.activeName === 'national') {
        detail.province_id = -1;
      } else {
        this.$message('操作异常，请联系管理员');
        return false;
      }
      this.copyTaskSumit(detail);
    },
    onCopyTask: function onCopyTask() {
      this.outerVisible = false;
      var detail = {
        task_id: this.taskid
      };
      this.copyTaskSumit(detail);
    },
    copyTaskSumit: function copyTaskSumit(detail) {
      var _this = this;

      detail = this.appendCopyConfig(detail);
      return request.alert('copyTask', detail).then(function (res) {
        _this.$message({
          showClose: true,
          message: '复制任务成功',
          type: 'success'
        });
        _this.outerVisible = false;
        _this.innerVisible = false;
        if (_this.$refs.provinces) {
          _this.$refs.provinces.form = {
            provinceid: null,
            cityid: null,
            areaid: null
          };
        }
        _this.$store.commit('OPEN_LOADING');
        setTimeout(function () {
          _this.$emit('search');
          _this.$store.commit('CLOSE_LOADING');
        }, 2000);
      });
    },
    batchCopyTaskSumit: function batchCopyTaskSumit(detail) {
      var _this2 = this;

      detail = this.appendCopyConfig(detail);
      return request.alert('batchCopyTask', detail).then(function (res) {
        _this2.$message({
          showClose: true,
          message: '操作成功，请前往批量任务查看',
          type: 'success'
        });
        _this2.outerVisible = false;
        _this2.innerVisible = false;
        _this2.$emit('search');
      });
    },
    handleClick: function handleClick(tab, event) {
      this.form.selectMarket = null;
    },
    getMarketInfo: function getMarketInfo(detail) {
      if (this.selectMarket) {
        this.selectMarket += '\n' + detail.marketname + '/' + detail.id;
      } else {
        this.selectMarket = detail.marketname + '/' + detail.id;
      }
    },
    onAddMarket: function onAddMarket() {
      this.form.selectMarket = this.selectMarket;
    },
    showDialog: function showDialog() {
      var _this3 = this;

      this.outerVisible = true;
      request.common('getCopyTaskInfo', { id: this.taskid }).then(function (data) {
        _this3.copyInfo = data.data;
        _this3.copyConfig.whitelisttags = _this3.copyInfo.whitelisttags.map(function (value) {
          return value.id;
        });
        _this3.copyConfig.blacklisttags = _this3.copyInfo.blacklisttags.map(function (value) {
          return value.id;
        });

        var whitelist = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(_this3.copyInfo.whitelist);
        var blacklist = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(_this3.copyInfo.blacklist);

        _this3.copyConfig.whitelistString = '没有任务白名单';
        _this3.copyConfig.blacklistString = '没有任务黑名单';

        if (_this3.copyInfo.whitelist.length) {
          _this3.copyConfig.whitelistString = whitelist.splice(0, 3).join(',');
          if (_this3.copyInfo.whitelist.length > 3) {
            _this3.copyConfig.whitelistString += '......等' + _this3.copyInfo.whitelist.length + '个';
          }
        }

        if (_this3.copyInfo.blacklist.length) {
          _this3.copyConfig.blacklistString = blacklist.splice(0, 3).join(',');
          if (_this3.copyInfo.blacklist.length > 3) {
            _this3.copyConfig.blacklistString += '......等' + _this3.copyInfo.blacklist.length + '个';
          }
        }
      }).catch(function (error) {
        // 暂时无法复制中台项目下的任务
        if (_.get(error, 'response.data.ret') === 387) {
          _this3.outerVisible = false;
        }
      });
    },
    appendCopyConfig: function appendCopyConfig(detail) {
      if (this.copyConfigSwitch.blacklist && this.copyInfo.blacklist) {
        detail.blacklist = this.copyInfo.blacklist;
      }

      if (this.copyConfigSwitch.whitelist && this.copyInfo.whitelist) {
        detail.whitelist = this.copyInfo.whitelist;
      }

      if (this.copyConfigSwitch.blacklisttags && this.copyConfig.blacklisttags) {
        detail.blacklisttags = this.copyConfig.blacklisttags;
      }

      if (this.copyConfigSwitch.whitelisttags && this.copyConfig.whitelisttags) {
        detail.whitelisttags = this.copyConfig.whitelisttags;
      }

      return detail;
    }
  })
});

/***/ }),

/***/ 1704:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  props: {},
  data: function data() {
    return {
      outerVisible: false,
      innerVisible: false,
      activeName: 'list',
      form: {
        provinceid: null,
        cityid: null,
        areaid: null
      },
      provinces: [],
      citys: [],
      areas: []
    };
  },

  methods: {
    onGetProvinces: function onGetProvinces(status) {
      var _this = this;

      if (status === true && this.provinces.length <= 0) {
        request.alert('getProvinces').then(function (_ref) {
          var data = _ref.data;

          _this.provinces = data;
        });
      }
    },
    onGetCitys: function onGetCitys(status) {
      var _this2 = this;

      if (status === true && this.citys.length <= 0 && this.form.provinceid) {
        request.alert('getCities', { pid: this.form.provinceid }).then(function (_ref2) {
          var data = _ref2.data;

          _this2.citys = data;
        });
      }
    },
    onGetAreas: function onGetAreas(status) {
      var _this3 = this;

      if (status === true && this.areas.length <= 0 && this.form.cityid) {
        request.alert('getDistricts', { pid: this.form.cityid }).then(function (_ref3) {
          var data = _ref3.data;

          _this3.areas = data;
        });
      }
    },
    onGetData: function onGetData() {
      if (this.form.areaid) {
        return this.form.areaid;
      } else if (this.form.cityid) {
        return this.form.cityid;
      } else {
        return this.form.provinceid;
      }
    },
    onProvinceChange: function onProvinceChange() {
      this.citys = [];
      this.form.cityid = null;
    },
    onCityChange: function onCityChange() {
      this.areas = [];
      this.form.areaid = null;
    },
    onAreaChange: function onAreaChange() {}
  }
});

/***/ }),

/***/ 1705:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  props: {
    taskid: String,
    status: Number
  },
  methods: {
    onSubmit: function onSubmit() {
      var _this = this;

      return this.$confirm('您确定要删除吗？', '提示', { type: 'warning' }).then(function (_) {
        return request.alert('taskDelete', { taskid: _this.taskid }).then(function (_) {
          _this.$message.success('删除成功！');
          _this.$store.commit('OPEN_LOADING');
          setTimeout(function () {
            _this.$emit('search');
            _this.$store.commit('CLOSE_LOADING');
          }, 2000);
        });
      });
    }
  }
});

/***/ }),

/***/ 1796:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TaskBatchPublishButton_vue__ = __webpack_require__(1700);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c8e5a0d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TaskBatchPublishButton_vue__ = __webpack_require__(2087);
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TaskBatchPublishButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c8e5a0d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TaskBatchPublishButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1797:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TaskBatchDeleteButton_vue__ = __webpack_require__(1701);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64e53984_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TaskBatchDeleteButton_vue__ = __webpack_require__(2088);
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TaskBatchDeleteButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64e53984_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TaskBatchDeleteButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1798:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TaskPublishOnSearchButton_vue__ = __webpack_require__(1702);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ebf05d5a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TaskPublishOnSearchButton_vue__ = __webpack_require__(2089);
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TaskPublishOnSearchButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ebf05d5a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TaskPublishOnSearchButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 2086:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TaskOperationButtons_vue__ = __webpack_require__(1699);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d5826dc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TaskOperationButtons_vue__ = __webpack_require__(2096);
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TaskOperationButtons_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d5826dc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TaskOperationButtons_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 2087:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('el-button',{attrs:{"type":"danger","size":"mini"},on:{"click":_vm.onStatisticalTotal}},[_vm._t("default")],2),_vm._v(" "),_c('el-dialog',{attrs:{"title":"批量发布确认","visible":_vm.dialogVisible,"width":"30%"},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('span',[_vm._v("共选任务:"+_vm._s(_vm.multipleSelection.length)+",其中有效任务:"+_vm._s(_vm.validAmount)+",请输入总金额"+_vm._s(_vm.salary))]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('el-input',{attrs:{"placeholder":"请输入总金额"},model:{value:(_vm.inputSalary),callback:function ($$v) {_vm.inputSalary=$$v},expression:"inputSalary"}}),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"size":"mini"},on:{"click":function($event){_vm.dialogVisible = false}}},[_vm._v("取 消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":_vm.onSubmit}},[_vm._v("确 定")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 2088:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{attrs:{"type":"danger","size":"mini"},on:{"click":_vm.onSubmit}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 2089:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"inline-block"}},[_c('el-button',{attrs:{"type":"danger","size":"mini"},on:{"click":_vm.open}},[_vm._t("default")],2),_vm._v(" "),_c('el-dialog',{attrs:{"title":"发布搜索结果确定","visible":_vm.visible,"before-close":_vm.close,"width":"30%"},on:{"update:visible":function($event){_vm.visible=$event}}},[_c('span',[_vm._v("共"+_vm._s(_vm.count)+"个任务，请输入总金额："+_vm._s(_vm.salary))]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('el-input',{attrs:{"placeholder":"请输入总金额"},model:{value:(_vm.inputSalary),callback:function ($$v) {_vm.inputSalary=$$v},expression:"inputSalary"}}),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"size":"mini"},on:{"click":function($event){return _vm.close()}}},[_vm._v("取 消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"mini","loading":_vm.count <= 0},on:{"click":_vm.onSubmit}},[_vm._v("确 定")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 2090:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TaskCopyButton_vue__ = __webpack_require__(1703);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ce07fefe_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TaskCopyButton_vue__ = __webpack_require__(2093);
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TaskCopyButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ce07fefe_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TaskCopyButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 2091:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AreaSearch_vue__ = __webpack_require__(1704);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53992a00_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AreaSearch_vue__ = __webpack_require__(2092);
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AreaSearch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53992a00_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AreaSearch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 2092:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-row',{attrs:{"gutter":24}},[_c('el-col',{attrs:{"span":8}},[_c('el-select',{attrs:{"placeholder":"请选择"},on:{"visible-change":_vm.onGetProvinces,"change":_vm.onProvinceChange},model:{value:(_vm.form.provinceid),callback:function ($$v) {_vm.$set(_vm.form, "provinceid", $$v)},expression:"form.provinceid"}},_vm._l((_vm.provinces),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}),1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('el-select',{attrs:{"placeholder":"请选择","disabled":!_vm.form.provinceid},on:{"visible-change":_vm.onGetCitys,"change":_vm.onCityChange},model:{value:(_vm.form.cityid),callback:function ($$v) {_vm.$set(_vm.form, "cityid", $$v)},expression:"form.cityid"}},_vm._l((_vm.citys),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}),1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('el-select',{attrs:{"placeholder":"请选择","disabled":!_vm.form.cityid},on:{"visible-change":_vm.onGetAreas,"change":_vm.onAreaChange},model:{value:(_vm.form.areaid),callback:function ($$v) {_vm.$set(_vm.form, "areaid", $$v)},expression:"form.areaid"}},_vm._l((_vm.areas),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}),1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 2093:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"inline-block"}},[_c('el-button',{attrs:{"type":"info","size":"mini"},on:{"click":_vm.showDialog}},[_vm._t("default")],2),_vm._v(" "),_c('el-dialog',{attrs:{"title":"操作提示","visible":_vm.outerVisible,"modal":false},on:{"update:visible":function($event){_vm.outerVisible=$event}}},[_c('el-dialog',{attrs:{"width":"50%","title":"批量复制更改门店","visible":_vm.innerVisible,"append-to-body":""},on:{"update:visible":function($event){_vm.innerVisible=$event}}},[_c('el-tabs',{on:{"tab-click":_vm.handleClick},model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[_c('el-tab-pane',{attrs:{"label":"批量列表","name":"list"}},[_c('el-input',{attrs:{"type":"textarea","autosize":"","placeholder":"格式: 超市名称/ID(回车分隔符)","autosize":{ minRows: 4 }},model:{value:(_vm.form.selectMarket),callback:function ($$v) {_vm.$set(_vm.form, "selectMarket", $$v)},expression:"form.selectMarket"}})],1),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"超市","name":"market"}},[_c('el-col',{attrs:{"span":20}},[_c('remote-select',{attrs:{"placeholder":"请输入","label-key":"marketname","id-key":"id","queryParams":{status: 1},"query-request":_vm.queryMarket},on:{"change":_vm.getMarketInfo},model:{value:(_vm.marketid),callback:function ($$v) {_vm.marketid=$$v},expression:"marketid"}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":2,"offset":2}},[_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":_vm.onAddMarket}},[_vm._v("添加\n            ")])],1),_vm._v(" "),_c('el-col',{staticStyle:{"margin-top":"15px"}},[_c('el-input',{attrs:{"type":"textarea","autosize":"","placeholder":"格式: 超市名称/ID(回车分隔符)","autosize":{ minRows: 4 }},model:{value:(_vm.form.selectMarket),callback:function ($$v) {_vm.$set(_vm.form, "selectMarket", $$v)},expression:"form.selectMarket"}})],1)],1),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"区域","name":"area"}},[_c('area-search',{ref:"provinces"})],1),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"全国","name":"national"}})],1),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":_vm.onSubmit}},[_vm._v("\n        提交\n      ")])],1),_vm._v(" "),_c('div',{staticStyle:{"margin-bottom":"20px","font-size":"larger"}},[_vm._v("\n      是否需要更换门店？\n    ")]),_vm._v(" "),_c('div',[_c('el-checkbox',{attrs:{"disabled":_vm.copyInfo.blacklist.length === 0},model:{value:(_vm.copyConfigSwitch.blacklist),callback:function ($$v) {_vm.$set(_vm.copyConfigSwitch, "blacklist", $$v)},expression:"copyConfigSwitch.blacklist"}},[_vm._v("保留任务黑名单："+_vm._s(_vm.copyConfig.blacklistString)+"\n      ")])],1),_vm._v(" "),_c('div',[_c('el-checkbox',{attrs:{"disabled":_vm.copyInfo.whitelist.length === 0},model:{value:(_vm.copyConfigSwitch.whitelist),callback:function ($$v) {_vm.$set(_vm.copyConfigSwitch, "whitelist", $$v)},expression:"copyConfigSwitch.whitelist"}},[_vm._v("保留任务白名单："+_vm._s(_vm.copyConfig.whitelistString)+"\n      ")])],1),_vm._v(" "),_c('div',[_c('el-checkbox',{attrs:{"disabled":_vm.copyInfo.blacklisttags.length === 0},model:{value:(_vm.copyConfigSwitch.blacklisttags),callback:function ($$v) {_vm.$set(_vm.copyConfigSwitch, "blacklisttags", $$v)},expression:"copyConfigSwitch.blacklisttags"}},[_vm._v("保留任务黑名单标签：")]),_vm._v(" "),_c('el-select',{attrs:{"multiple":"","placeholder":_vm.copyInfo.blacklisttags.length === 0 ? '无可选择项' : '请选择',"disabled":_vm.copyInfo.blacklisttags.length === 0},model:{value:(_vm.copyConfig.blacklisttags),callback:function ($$v) {_vm.$set(_vm.copyConfig, "blacklisttags", $$v)},expression:"copyConfig.blacklisttags"}},_vm._l((_vm.copyInfo.blacklisttags),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.tagname,"value":item.id}})}),1)],1),_vm._v(" "),_c('div',[_c('el-checkbox',{attrs:{"disabled":_vm.copyInfo.whitelisttags.length === 0},model:{value:(_vm.copyConfigSwitch.whitelisttags),callback:function ($$v) {_vm.$set(_vm.copyConfigSwitch, "whitelisttags", $$v)},expression:"copyConfigSwitch.whitelisttags"}},[_vm._v("保留任务白名单标签：")]),_vm._v(" "),_c('el-select',{attrs:{"multiple":"","placeholder":_vm.copyInfo.whitelisttags.length === 0 ? '无可选择项' : '请选择',"disabled":_vm.copyInfo.whitelisttags.length === 0},model:{value:(_vm.copyConfig.whitelisttags),callback:function ($$v) {_vm.$set(_vm.copyConfig, "whitelisttags", $$v)},expression:"copyConfig.whitelisttags"}},_vm._l((_vm.copyInfo.whitelisttags),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.tagname,"value":item.id}})}),1)],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"size":"mini"},on:{"click":_vm.onCopyTask}},[_vm._v("不需要\n      ")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":function($event){_vm.innerVisible = true}}},[_vm._v("需要\n      ")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 2094:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TaskDeleteButton_vue__ = __webpack_require__(1705);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01894150_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TaskDeleteButton_vue__ = __webpack_require__(2095);
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TaskDeleteButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01894150_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TaskDeleteButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 2095:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.status === 0 || _vm.status === 1)?_c('el-button',{attrs:{"type":"danger","size":"mini"},on:{"click":_vm.onSubmit}},[_vm._t("default")],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 2096:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button-gutter',[(![23, 127].includes(_vm.scope.row.type))?[(_vm.scope.row.status === 0 )?_c('el-button',{attrs:{"type":"danger","size":"mini"},on:{"click":function($event){return _vm.$emit('publish', _vm.scope.row)}}},[_vm._v("发布\n        ")]):_vm._e(),_vm._v(" "),_c('task-copy-button',{staticClass:"button-gutter-item",attrs:{"taskid":_vm.scope.row.taskid + ''},on:{"search":_vm.onSearch}},[_vm._v("复制\n        ")]),_vm._v(" "),(_vm.scope.row.status === 0 || _vm.scope.row.status === 1)?_c('router-link',{attrs:{"to":'/task/update/'+_vm.scope.row.taskid}},[_c('el-button',{attrs:{"type":"primary","size":"mini"}},[_vm._v("修改\n            ")])],1):_vm._e(),_vm._v(" "),_c('task-delete-button',{attrs:{"status":_vm.scope.row.status,"taskid":_vm.scope.row.taskid + ''},on:{"search":_vm.onSearch}},[_vm._v("删除\n        ")]),_vm._v(" "),_c('router-link',{attrs:{"to":{path: '/task/preview-app/'+_vm.scope.row.taskid,query:{userid: '1'}}}},[_c('el-button',{attrs:{"type":"success","size":"mini"}},[_vm._v("预览任务\n            ")])],1)]:_vm._e(),_vm._v(" "),(_vm.scope.row.type === 127)?_c('router-link',{attrs:{"to":{path: '/task/md/table/'+_vm.scope.row.taskid}}},[_c('el-button',{attrs:{"type":"success","size":"mini"}},[_vm._v("查看包含任务\n            ")])],1):_vm._e(),_vm._v(" "),(_vm.scope.row.marketid !== 0)?_c('router-link',{attrs:{"to":{path: '/task/nearby-users/'+_vm.scope.row.taskid}}},[_c('el-button',{attrs:{"type":"success","size":"mini"}},[_vm._v("周边零工\n            ")])],1):_vm._e()],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 3003:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_mixins_table__ = __webpack_require__(1346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__task_mixins__ = __webpack_require__(1512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__order_components_OrderSearch__ = __webpack_require__(1658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_buttons_TaskBatchPublishButton__ = __webpack_require__(1796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_buttons_TaskBatchDeleteButton__ = __webpack_require__(1797);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_task_components_buttons_TaskPublishOnSearchButton__ = __webpack_require__(1798);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_task_components_buttons_TaskOperationButtons__ = __webpack_require__(2086);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_buttons_TaskDescButton__ = __webpack_require__(1555);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__core_mixins_table__["b" /* default */], __WEBPACK_IMPORTED_MODULE_2__task_mixins__["a" /* default */]],
  components: {
    TaskBatchPublishButton: __WEBPACK_IMPORTED_MODULE_4__components_buttons_TaskBatchPublishButton__["a" /* default */],
    TaskBatchDeleteButton: __WEBPACK_IMPORTED_MODULE_5__components_buttons_TaskBatchDeleteButton__["a" /* default */],
    TaskPublishOnSearchButton: __WEBPACK_IMPORTED_MODULE_6__views_task_components_buttons_TaskPublishOnSearchButton__["a" /* default */],
    TaskOperationButtons: __WEBPACK_IMPORTED_MODULE_7__views_task_components_buttons_TaskOperationButtons__["a" /* default */],
    OrderSearch: __WEBPACK_IMPORTED_MODULE_3__order_components_OrderSearch__["a" /* default */],
    TaskDescButton: __WEBPACK_IMPORTED_MODULE_8__components_buttons_TaskDescButton__["a" /* default */]
  },
  data: function data() {
    return {
      table: [],
      type: 2,
      projectType: 0,
      multipleSelection: [],
      dialogVisible: false,
      dialogBatchVisible: false,
      search: {
        id: '',
        onlineRange: [],
        offlineRange: [],
        reformat: 1,
        start_begin: null,
        start_end: null,
        endtime_begin: null,
        endtime_end: null,
        customerid: null,
        projectid: null,
        type: null,
        batchid: null,
        status: null,
        templateid: null,
        userid: null,
        taskmarketareaid: null,
        marketname: null,
        locked: null,
        text: null,
        review_begin: null,
        review_end: null,
        sort_by_review: null,
        sort_by_lastupdatetime: null
      },
      // 搜索字段申明
      searchFieldType: {
        type: Number,
        status: Number,
        locked: Number,
        review_begin: Number,
        review_end: Number,
        taskmarketareaid: Number
      },
      exportAsync: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Vuex.mapState({
    options: function options(state) {
      return state.order.options;
    }
  }), {
    // 批量发布任务的项目成本检查, 必须保证要发布的任务是一个项目的
    isSearchProjectScope: function isSearchProjectScope() {
      return this.lastSeachParams.projectid > 0 || this.lastSeachParams.batchid > 0;
    }
  }),
  created: function created() {},

  methods: {
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData: function getTableData(params) {
      params.id = this.$route.params.id;
      return request.page('getMiDanTaskTable', params);
    },
    onExportPage: function onExportPage(onlyBasic) {
      this.dialogVisible = false;
      if (this.multipleSelection.length <= 0) {
        this.$message.error('请至少选择批量导出一个');
        return false;
      }
      var multipleIds = {
        'taskid': this.multipleSelection.map(function (item) {
          return item.taskid;
        }),
        'only_basic': onlyBasic,
        'export_async': this.exportAsync
      };
      if (this.exportAsync) {
        return this.onExportAsync(multipleIds);
      }
      this.$export(this.$route.meta.title + '-' + this.pagination.current_page + 'P', {
        fileHeader: this.exportHeader,
        total: multipleIds.taskid.length,
        request: function (_request) {
          function request(_x) {
            return _request.apply(this, arguments);
          }

          request.toString = function () {
            return _request.toString();
          };

          return request;
        }(function (params) {
          return request('exportTask', params);
        }),
        requestParams: multipleIds,
        fileType: 'csv',
        type: 'array',
        getResponseData: function getResponseData(data) {
          // 导出大于一页时去掉标题行
          data.current_page > 1 && data.data.splice(0, 1);
          return data;
        }
      });
    },
    onBatchExportSearch: function onBatchExportSearch(onlyBasic) {
      this.dialogBatchVisible = false;
      var detail = this.search;
      detail.only_basic = onlyBasic;
      detail.export_async = this.exportAsync;

      if (this.exportAsync) {
        return this.onExportAsync(detail);
      }

      this.$export(this.$route.meta.title + '-' + this.pagination.current_page + 'P', {
        fileHeader: this.exportHeader,
        total: this.pagination.length,
        request: function (_request2) {
          function request(_x2) {
            return _request2.apply(this, arguments);
          }

          request.toString = function () {
            return _request2.toString();
          };

          return request;
        }(function (params) {
          return request('exportTask', params);
        }),
        requestParams: detail,
        fileType: 'csv',
        type: 'array',
        getResponseData: function getResponseData(data) {
          // 导出大于一页时去掉标题行
          data.current_page > 1 && data.data.splice(0, 1);
          return data;
        }
      });
    },
    cleanMultipleSelection: function cleanMultipleSelection() {
      this.$refs.multipleTable.clearSelection();
      this.onSearch();
    },
    onExportAsync: function onExportAsync(detail) {
      var _this = this;

      if (detail.export_async) {
        request.common('exportTask', detail).then(function () {
          _this.$message.success('创建成功，请在任务管理中心查看！');
        });
      }
    },
    showExportDialog: function showExportDialog() {
      this.dialogVisible = true;
      this.exportAsync = false;
    },
    showExportSearchDialog: function showExportSearchDialog() {
      this.dialogBatchVisible = true;
      this.exportAsync = false;
    },
    salaryValue: function salaryValue(value) {
      return filter.hasPermission(250) ? value : '*';
    }
  }
});

/***/ }),

/***/ 5501:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5502);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("2daf067a", content, true, {});

/***/ }),

/***/ 5502:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "a[data-v-273e81b6]{text-decoration:none}.blue-color[data-v-273e81b6]{color:#589df8}.el-dialog .el-checkbox[data-v-273e81b6]{white-space:normal}.el-dialog .el-checkbox[data-v-273e81b6] .el-checkbox__label{display:inline}", "", {"version":3,"sources":["/workspace/src/views/task/pages/MidanTaskTable.vue"],"names":[],"mappings":"AACA,mBAAmB,oBAAoB,CACtC,AACD,6BAA6B,aAAa,CACzC,AACD,yCAAyC,kBAAkB,CAC1D,AACD,6DAA6D,cAAc,CAC1E","file":"MidanTaskTable.vue","sourcesContent":["\na[data-v-273e81b6]{text-decoration:none\n}\n.blue-color[data-v-273e81b6]{color:#589df8\n}\n.el-dialog .el-checkbox[data-v-273e81b6]{white-space:normal\n}\n.el-dialog .el-checkbox[data-v-273e81b6] .el-checkbox__label{display:inline\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 5503:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading",staticStyle:{"position":"relative"}},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":"/"}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',{attrs:{"to":"/task/table"}},[_vm._v("任务管理")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('layout-panel',[_c('template',{slot:"header"},[_vm._v("米单任务列表")]),_vm._v(" "),_c('el-table',{ref:"multipleTable",staticStyle:{"width":"100%"},attrs:{"data":_vm.table,"stripe":"","highlight-current-row":"","border":""}},[_c('el-table-column',{attrs:{"prop":"taskid","width":"116px","label":"任务ID"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n          TSK"+_vm._s(scope.row.taskid)+"\n        ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"title","label":"任务标题"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('router-link',{attrs:{"to":'/task/detail/'+scope.row.taskid}},[_c('span',{staticStyle:{"color":"rgb(88, 157, 248)"}},[_vm._v(_vm._s(scope.row.title))])])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"type","label":"任务类型","width":"51px"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return _vm._l((_vm.options.allType),function(item){return (scope.row.type === item.value)?_c('span',[_vm._v(_vm._s(item.label))]):_vm._e()})}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"assignnum","label":"完成人","width":"84px"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.assignnum)?_c('router-link',{staticStyle:{"text-decoration":"none"},attrs:{"to":'/order/table?taskid='+scope.row.taskid}},[_c('span',{staticStyle:{"color":"rgb(88,157,248)"}},[_vm._v(_vm._s(scope.row.assignnum))])]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"salary","label":"赏金","width":"65px"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n          "+_vm._s(_vm.salaryValue(scope.row.salary))+"\n        ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"任务时间","width":"94px"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n          "+_vm._s(scope.row.starttime)),_c('br'),_vm._v(_vm._s(scope.row.endtime)+"\n        ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"城市","width":"162px"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n          "+_vm._s(scope.row.provincename)+_vm._s(scope.row.cityname)+_vm._s(scope.row.areaname)+"\n        ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"marketname","label":"门店名称"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('router-link',{attrs:{"to":'/market/table?id='+scope.row.marketid,"target":"_blank"}},[_vm._v("\n            "+_vm._s(scope.row.marketname)+"\n          ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"status","label":"任务状态","width":"92px"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return _vm._l((_vm.options.status),function(item){return (scope.row.status === item.value)?_c('span',[_vm._v(_vm._s(item.label)+"\n          ")]):_vm._e()})}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"adminname","label":"任务发布人","width":"94px"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"customer","label":"所属客户","width":"84px"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.customerid)?_c('span',[_vm._v(_vm._s(scope.row.customer_name)+"/"+_vm._s(scope.row.customer_number))]):_vm._e(),_vm._v(" "),(!scope.row.customerid)?_c('span',[_vm._v("平台")]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"发布时间","sortable":"custom","width":"94px","prop":"publishtime"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n          "+_vm._s(scope.row.publishtime)),_c('br'),_vm._v("\n          "+_vm._s(scope.row.lastupdatetime)+"\n        ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"right","label":"操作","width":"145"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('TaskOperationButtons',{attrs:{"scope":scope},on:{"publish":function($event){return _vm.onPublishTask(scope.row)}}})]}}])})],1),_vm._v(" "),_c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"background":"","current-page":_vm.pagination.current_page,"page-sizes":[20, 50, 100, 200],"page-size":_vm.pagination.per_page,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.pagination.total},on:{"size-change":_vm.handleSizePageChange,"current-change":_vm.handleCurrentPageChange}})],1)],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/MidanTaskTable.939e33ff873a847a271a.js